import { accessRole } from "../../../../../helpers/access_role";
import { config } from "../../../../../helpers/config_global";
import React, { useState, Component, Fragment } from "react";
import { Redirect } from "react-router-dom";

import { Tooltip } from "reactstrap";

import MKIDatatable from "../../../../../modules/mki-datatable/lib";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/organizationhistoriService";

import apiResponse from "../../../../../services/apiResponse";
// import DataTableBloc from '../Blocs/DataTableBloc'
import IndexBloc from "../../Index/Blocs/IndexBloc";
import MinioClient from "../../../../../services/minioClient";

const reformatDate = (date) => {
  const months = [
    "Jan", "Feb", "Mar", "Apr", "Mei", "Jun",
    "Jul", "Ags", "Sep", "Okt", "Nov", "Des"
  ];
  if (!date) return "-";

  const d = new Date(date);
  let dt = d.getDate();
  if (dt < 10) dt = "0" + dt;
  
  let hr = d.getHours();
  if (hr < 10) hr = "0" + hr;
  
  let mn = d.getMinutes();
  if (mn < 10) mn = "0" + mn;

  return `${dt} ${months[d.getMonth()]} ${d.getFullYear()} ${hr}:${mn}`;
};

class TableComponent extends Component {
  indexBloc = new IndexBloc();
  minioClient = new MinioClient();
  source;
  defaultOrder = "employee_transfer_detail_id";
  defaultSize = 10;
  defaultSort = "desc";
  configDatatable = {
    ...config("datatable"),
    sort: {
      column: this.defaultOrder,
      order: this.defaultSort,
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      tooltip: false,
      detailUuid: null,
      updateUuid: null,
      approveUuid: null,
      inactiveUuid: null,
      defaultSize: 10,
      rows: [],
      totalRow: 0,
      loadingTable: true,
      filter: {
        filter_value: "",
        page_number: 1,
        page_size: this.defaultSize,
        sort_order: {
          column: this.defaultOrder,
          order: this.defaultSort,
        },
      },
    };
  }
  toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

  loadData = async () => {
    /* kirim ke server */
    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }
    const query = {
      uuid: this.props?.uuid,
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: 1,
    };
    await this.indexBloc.fetchListDetail(query, this.source.token);
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadData();
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.inactiveData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  inactiveData = async () => {
    await this.indexBloc.fetchInactiveDetail({ uuid: this.state.inactiveUuid });
  };

  componentDidMount() {
    this.setTokenAPI();

    this.indexBloc.listDetailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            totalRow: response.total,
            rows: response.result,
            loadingTable: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.indexBloc.inactiveDetailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState(
            {
              loading: false,
              success: true,
              loadingTable: true,
            },
            function () {
              this.setTokenAPI();
              this.props.handleInactiveSuccess();
            }
          );
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.indexBloc.listDetailChannel?.unsubscribe();
    this.indexBloc.inactiveDetailChannel?.unsubscribe();
  }
  columns = [
    {
      key: "employee_transfer_detail_employee_full_name",
      text: "Pegawai",
      sortable: true,
      width: "25%",
      cell: (record) => {
        return (
          <Fragment>
            <b>{record.employee_nip}</b>
            <br />
            {record.employee_transfer_detail_employee_full_name}
          </Fragment>
        );
      },
    },
    {
      key: "jenis_mutasi",
      text: "Jenis Mutasi",
      sortable: false,
      width: "25%",
      cell: (record) => {
        return (
          <Fragment>
            <b>{record.jenis_mutasi}</b>
          </Fragment>
        );
      },
    },
    {
      key: "created_by_uuid",
      text: "Dibuat Oleh",
      sortable: true,
      cell: (record) => {
        return (
          <div>
            <span className="d-block font-size-12">{record.created_by_uuid || '-'}</span>
            <span className="text-muted font-size-11">{reformatDate(record.employee_transfer_detail_create_date)}</span>
          </div>
        );
      },
    },
    {
      key: "updated_by_uuid",
      text: "Diubah Oleh",
      sortable: true,
      cell: (record) => {
        return (
          <div>
            <span className="d-block font-size-12">{record.updated_by_uuid || '-'}</span>
            <span className="text-muted font-size-11">{record.employee_transfer_detail_log_date ? reformatDate(record.employee_transfer_detail_log_date) : '-'}</span>
          </div>
        );
      },
    },
    {
      key: "action",
      text: "Action",
      className: "action",
      width: 120,
      sortable: false,
      align: "center",
      cell: (record) => {
        const thisId = record.employee_transfer_detail_id;
        return (
          <Fragment>
            <span>
              <button
                className="btn btn-primary btn-sm"
                id={"update-" + thisId}
                onClick={() => {
                  this.setState({
                    updateUuid: record.employee_transfer_detail_uuid,
                  });
                }}
                style={{ marginRight: "2px", padding: "2px 5px" }}
              >
                <i className="uil-edit"></i>
              </button>
            </span>
            <span>
              <button
                className="btn btn-danger btn-sm"
                id={"delete-" + thisId}
                onClick={() => {
                  this.setState({
                    inactiveUuid: record.employee_transfer_detail_uuid,
                    confirm: true,
                  });
                }}
                style={{ marginRight: "2px", padding: "2px 5px" }}
              >
                <i className="uil-trash-alt"></i>
              </button>
            </span>
          </Fragment>
        );
      },
    },
  ];
  previewDocument(urlPath) {
    // alert(urlPath)
    this.setState({
      loading: true,
    });
    this.minioClient.get(urlPath).then((url) => {
      this.setState({
        loading: false,
      });
      alert(url);
      window.open(url, "_blank");
    });
  }

  render() {
    return (
      <Fragment>
        <MKIDatatable
          className={this.configDatatable.tableClass}
          config={this.configDatatable}
          records={this.state.rows}
          columns={this.columns}
          dynamic={true}
          minWidth={1000}
          total_record={this.state.totalRow}
          initial={this.state.filter}
          onChange={(filter) => {
            this.setState(
              {
                loadingTable: true,
                filter: filter,
              },
              function () {
                this.setTokenAPI();
              }
            );
          }}
          loading={this.state.loadingTable}
        />
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menghapus data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil dihapus"
          failedTitle="Gagal!"
          failedInfo="Data gagal dihapus"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.updateUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/mutasi_baru.html?create=1&uuid=" +
              this.props.uuid +
              "&detail_uuid=" +
              this.state.updateUuid
            }
          />
        ) : null}
      </Fragment>
    );
  }
}

export default TableComponent;
